import lottie from 'lottie-web';
import animationData from '../animations/AnimationArrow.json'; // Ensure your build system supports this

lottie?.loadAnimation({
	container: document?.getElementById('animation-container'),
	renderer: 'svg',
	loop: true,
	autoplay: true,
	animationData: animationData
});
